module.exports = __webpack_public_path__ + "img/other.89473a91.png";